import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { apiUrl, imageUrl } from '../../Constants/contant';

function BlogDetailsMain() {
    const { id } = useParams();
    const [blog, setBlog] = useState([]);
    

    useEffect(() => {
      fetch(apiUrl + 'blog-details/' + id)
        .then(response => response.json()) // ✅ JSON convert
        .then(data => {
          setBlog(data.blog);
          
        })
        .catch(error => {
          console.error("There was an error fetching sliders!", error);
        });
    }, []);

 


    return (
        <section className="th-blog-wrapper blog-details space-top space-extra-bottom">
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xxl-12 col-lg-7">
                        <div className="th-blog blog-single">
                            <div className="blog-img">
                                <img src={`${imageUrl}/${blog.image}`} alt="Blog Image" />
                            </div>
                            <div className="blog-content">
                                <div className="blog-meta">
                                   
                                    <Link to="/blog">
                                        <i className="fa-regular fa-calendar" />
                                       {blog?.date}
                                    </Link>
                                    <Link to="#">
                                        <img src="/assets/img/icon/map.svg" alt="" />
                                        Sea Beach
                                    </Link>
                                </div>
                                <h2 className="blog-title">
                                                                         {blog?.title}

                                </h2>
                                <p className="blog-text mb-30">
                                        {blog?.content}

                                </p>
                                {/* <p className="blog-text mb-30">
                                    A platform dedicated to exploring the transformative power of
                                    education. We believe that education is not only a means to
                                    acquire knowledge but also a catalyst for personal growth,
                                    societal progress, and global development. In this blog, we aim to
                                    inspire, inform, and engage readers in conversations about the
                                    latest trends, insights, and innovations in the field of
                                    education.
                                </p> */}
                               
                               
                            </div>
                        </div>
                       
                        {/* Comment end */} {/* Comment Form */}
                        
                    </div>
                   
                </div>
                <div
                    className="shape-mockup shape1 d-none d-xxl-block"
                    style={{ bottom: "5%", right: "-8%" }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape2 d-none d-xl-block"
                    style={{ bottom: "1%", right: "-7%" }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup shape3 d-none d-xxl-block"
                    style={{ bottom: "2%", right: "0%" }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>
        </section>

    )
}

export default BlogDetailsMain
